import React, { useState, useEffect } from "react"
import axios from "axios"
import { Row, Col, Card, CardBody } from "reactstrap"
import { AvForm, AvField } from "availity-reactstrap-validation"
import { getCurrentUser } from "../../../helpers/Utils"
import { toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import file2 from "../../../assets/files/smtp.pdf"

const EmailSMTP = () => {
  const [smtpDetails, setsmtpDetails] = useState({
  client: {},
  office: {},
})
  const [officeSMTP, setOfficeSMTP] = useState({})
  const [loading, setLoading] = useState(false)
  const [loadingOffice, setLoadingOffice] = useState(false)
  const downloadPDF2 = () => {
    saveAs(file2, "smtp_setup.pdf")
  }


  const smtpDetail = (e, value, type) => {
    if(type == 'client')
    {
      setLoading(true)
    }
    else
    {
      setLoadingOffice(true)
    }

      const currentSMTP = smtpDetails[type] || {}

      const url = `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
        "company_name"
      )}/smtp-detail`

      const payload = {
        username: value.username_smtp,
        password: value.password_smtp,
        type: type,
      }

      const headers = {
        Authorization: `Bearer ${getCurrentUser().token || ""}`,
      }

      const request = currentSMTP?.id
        ? axios.put(`${url}/${currentSMTP.id}`, payload, { headers })
        : axios.post(url, payload, { headers })

      request
        .then(res => {
          if(type == 'client')
          {
            setLoading(false)
          }
          else
          {
            setLoadingOffice(false)
          }
          

          if (res.data.status) {
            // ✅ Update only specific type (client/office)
            setsmtpDetails(prev => ({
              ...prev,
              [type]: res.data.data,
            }))

             toast.success(res.data.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            })

            window.history.go(-1)
          } else {
            toast.error(res.data.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            })
          }
        })
        .catch(() => {
          if(type == 'client')
          {
            setLoading(false)
          }
          else
          {
            setLoadingOffice(false)
          }
          toast.error('Something went wrong', {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            })
        })
    }
  

  const getSMTP = () => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
          "company_name"
        )}/smtp-detail/${getCurrentUser().id}`,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${
              getCurrentUser().token == null ? "" : getCurrentUser().token
            }`,
          },
        }
      )
      .then(function (res) {
        if (res.data.status) {
          setsmtpDetails({
          client: res.data.data.client || {},
          office: res.data.data.office || {},
        })
        } else {
          setError(res.data.message)
        }
      })
  }

  useEffect(() => {
    getSMTP()
  }, [])

  return (
    <>
      <div className="page-title-box">
        <Row className="align-items-center">
          <Col md={6}>
            <h4 className="page-title">Connect Gmail</h4>
          </Col>
          <Col md={6}>
            <h6 className="page-title float-end"></h6>
          </Col>
          <p>
                      Here is the pdf, how to set smtp.{" "}
                      <span
                        className="text-info"
                        style={{ cursor: "pointer" }}
                        onClick={() => downloadPDF2()}
                      >
                        click here...
                      </span>
                    </p>
        </Row>
      </div>
      <Row>
        <Col lg="12">
          {getCurrentUser().role_name === "Administrator" ? (
            <Card>
              <CardBody>
                <AvForm
                  className="card-title mt-0"
                  onValidSubmit={(e, v) => {
                    smtpDetail(e, v, 'client')
                  }}
                  autoComplete="off"
                >
                  <h4 className="card-title mb-4">SMTP Details for clients (Gmail only)</h4>
                  <hr />
                  <Row>
                    {/* <Col md={4}>
                                       <div className="mb-3">
                                          <AvField
                                             label="Host"
                                             type="text"
                                             name="host"
                                             placeholder="Enter Host Name"
                                             value={smtpDetails?.host}
                                          />
                                       </div>
                                       <div className="mb-3">
                                          <AvField
                                             label="Port"
                                             type="text"
                                             name="port"
                                             placeholder="Enter Port Name"
                                             value={smtpDetails?.port}
                                          />
                                       </div>
                                    </Col> */}
                    <Col md={6}>
                      <div className="mb-3">
                        <AvField
                          label="Username"
                          type="text"
                          name="username_smtp"
                          placeholder="Enter Username"
                          autoComplete="new-username"
                          value={smtpDetails?.client?.username || ""}
                        />
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="mb-3">
                        <AvField
                          label="Password"
                          type="password"
                          name="password_smtp"
                          placeholder="Enter Password"
                          autoComplete="new-password"
                          value={smtpDetails?.client?.password || ""}
                        />
                      </div>
                    </Col>
                    {/* <Col md={4}>
                                       <div className="mb-3">
                                          <AvField
                                             label="Encryption"
                                             type="text"
                                             name="encryption"
                                             placeholder="Enter encryption"
                                             value={smtpDetails?.encryption}
                                          />
                                       </div>
                                       <div className="mb-3">
                                          <AvField
                                             label="Email for CC"
                                             type="email"
                                             name="cc_email"
                                             placeholder="Enter email to add in CC"
                                             value={smtpDetails?.cc_email}
                                          />
                                       </div> 
                                    </Col> */}
                    
                    <hr />
                  </Row>
                  <div className="text-center">
                    {loading ? (
                      <button
                        className="btn btn-primary disabled"
                        type="button"
                        disabled
                      >
                        Loading
                      </button>
                    ) : (
                      <button
                        className="btn btn-primary"
                        type="submit"
                        // onClick={() => props.setmodal_dead_reason(false)}
                      >
                        Submit
                      </button>
                    )}
                  </div>
                </AvForm>

                 <AvForm
                  className="card-title mt-0"
                  onValidSubmit={(e, v) => {
                    smtpDetail(e, v, 'office')
                  }}
                  autoComplete="off"
                >
                  <h4 className="card-title mb-4">SMTP Details for office (Gmail only)</h4>
                  <hr />
                  <Row>
                    {/* <Col md={4}>
                                       <div className="mb-3">
                                          <AvField
                                             label="Host"
                                             type="text"
                                             name="host"
                                             placeholder="Enter Host Name"
                                             value={smtpDetails?.host}
                                          />
                                       </div>
                                       <div className="mb-3">
                                          <AvField
                                             label="Port"
                                             type="text"
                                             name="port"
                                             placeholder="Enter Port Name"
                                             value={smtpDetails?.port}
                                          />
                                       </div>
                                    </Col> */}
                    <Col md={6}>
                      <div className="mb-3">
                        <AvField
                          label="Username"
                          type="text"
                          name="username_smtp"
                          placeholder="Enter Username"
                          autoComplete="new-username"
                          value={smtpDetails?.office?.username || ""}
                        />
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="mb-3">
                        <AvField
                          label="Password"
                          type="password"
                          name="password_smtp"
                          placeholder="Enter Password"
                          autoComplete="new-password"
                          value={smtpDetails?.office?.password || ""}
                        />
                      </div>
                    </Col>
                    {/* <Col md={4}>
                                       <div className="mb-3">
                                          <AvField
                                             label="Encryption"
                                             type="text"
                                             name="encryption"
                                             placeholder="Enter encryption"
                                             value={smtpDetails?.encryption}
                                          />
                                       </div>
                                       <div className="mb-3">
                                          <AvField
                                             label="Email for CC"
                                             type="email"
                                             name="cc_email"
                                             placeholder="Enter email to add in CC"
                                             value={smtpDetails?.cc_email}
                                          />
                                       </div> 
                                    </Col> */}
                    
                    <hr />
                  </Row>
                  <div className="text-center">
                    {loadingOffice ? (
                      <button
                        className="btn btn-primary disabled"
                        type="button"
                        disabled
                      >
                        loadingOffice
                      </button>
                    ) : (
                      <button
                        className="btn btn-primary"
                        type="submit"
                        // onClick={() => props.setmodal_dead_reason(false)}
                      >
                        Submit
                      </button>
                    )}
                  </div>
                </AvForm>       




              </CardBody>
            </Card>
            
          ) : (
            ""
          )}
        </Col>
      </Row>
    </>
  )
}

export default EmailSMTP
